<template>
  <div class="card-container">
    <div class="c-header-container">
      <div class="c-header">
        TOTAL MEMBERS
      </div>
      <div class="sac__font-14 f-white">
        {{ heroDate }}
      </div>
    </div>
    <div class="c-number-container">
      <img
        v-if="loading && customersCount.totalMembersCount < 1"
        src="@shared/assets/img/general/loading-white.svg"
        class="loading"
        alt="loading"
      >
      <div v-else-if="customersCount.totalMembersCount === 0" class="sac__font-14 f-white med">
        No member onboarded yet
      </div>
      <div v-else class="c-number">
        {{ customersCount.totalMembersCount }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import customerMixin from '@shared/mixins/customerMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'TotalMemberCount',
  mixins: [customerMixin, unitPreferencesMixin],
  data() {
    const { partnerSettings } = this.$store.state.admin;
    const { DATE_FORMAT = 'MM-DD-YYYY' } = partnerSettings;

    const format = DATE_FORMAT === 'DD-MM-YYYY' ? 'D MMM, YYYY' : 'MMM D, YYYY';

    const today = moment().format(format);
    const heroDate = `As of ${today}`;

    return { heroDate };
  },
};
</script>
